<!--
  - Copyright (c) 2022-2023. Haodong JU
  -->

<template>
  <div
    class="d-flex flex-wrap align-center"
  >
    <v-card
      :class="!$vuetify.breakpoint.mdAndUp ? 'rounded-0' : ''"
      :style="!$vuetify.breakpoint.mdAndUp ? 'width: 100%;' : 'width: 480px;'"
      class="pa-4 d-flex flex-column"
      elevation="0"
    >
      <div class="d-flex align-center">
        <back-button
          @close-event="cancel"
        />
        <page-header class="py-4 pb-6">
          {{ $t('bills') }} · #{{ title }}
        </page-header>
      </div>
      <v-card
        :class="!$vuetify.breakpoint.mdAndUp ? 'align-center' : 'align-end'"
        class="d-flex flex-wrap justify-space-between"
        elevation="0"
        style="width: 100%;"
      >
        <div :class="!$vuetify.breakpoint.mdAndUp ? 'mt-4' : ''">
          <div class="totalBlock">
            <div>
              <v-chip
                color="primary"
                dark
                label
                small
              >
                {{ $t('total_payable') }}
              </v-chip>
            </div>
            <span class="totalNumber">
              {{ total|priceDisplay }}
            </span>
          </div>
          <div class="totalBlock">
            <div>
              <v-chip
                class="font-weight-bold"
                color="error"
                dark
                label
                small
              >
                {{ $t('payment_still_required') }}
              </v-chip>
            </div>
            <span class="totalNumber">
              {{ remainTotal|priceDisplay }}
            </span>
          </div>
        </div>
        <div
          :class="!$vuetify.breakpoint.mdAndUp ? 'd-flex flex-wrap justify-end' : ''"
          :style="!$vuetify.breakpoint.mdAndUp ? 'width: 100%;' : ''"
          class="totalBlock"
        >
          <div>
            <v-chip
              color="success"
              dark
              label
            >
              {{ $t('will_have_to_pay') }}
            </v-chip>
          </div>
          <div :style="!$vuetify.breakpoint.mdAndUp ? 'width: 100%;' : 'width: 240px; height: 64px;'">
            <v-text-field
              v-model="inputBuffer"
              :placeholder="''+remainTotal.toFixed(2)"
              class="text-right"
              height="64px"
              reverse
              style="font-size: 34px"
            />
          </div>
        </div>
      </v-card>
      <div>
        <h4>{{ $t('other_paymethod') }}</h4>
        <div
          class="pa-1 mt-1"
          style="display: grid;grid-auto-columns: 96px;grid-gap: 8px;
           overflow-x: scroll;grid-auto-flow: column"
        >
          <v-card
            v-for="(item, index) in realExtraPaymentMethodName"
            :key="index"
            class="pa-2"
            color="#f6f6f6"
            elevation="0"
            style="height: 96px"
            @click="input(item)"
          >
            {{ item }}
          </v-card>
        </div>
      </div>
      <div>
        <div class="keyboard">
          <!--                keyBoard-->
          <template v-for="i in keyArr.flat()">
            <v-btn
              v-if="i!=='mdi-dots-horizontal'"
              :key="'key'+i"
              :elevation="0"
              :ripple="false"
              block
              class="key"
              style="height: 96px; color: black"
              width="100%"
              x-large
              @click="input(i)"
            >
              <v-icon
                v-if="!isNaN(i)"
                x-large
              >
                mdi-numeric-{{ i }}
              </v-icon>
              <v-icon
                v-else
                x-large
              >
                {{ i }}
              </v-icon>
            </v-btn>
            <v-menu
              v-else
              :key="'key'+i"
              offset-x
            >
              <template #activator="{ on, attrs }">
                <v-btn
                  :key="'key'+i"
                  :elevation="0"
                  block
                  class="key"
                  style="height: 96px"
                  v-bind="attrs"
                  x-large
                  @click="input(i)"
                  v-on="on"
                >
                  <v-icon x-large>
                    {{ i }}
                  </v-icon>
                </v-btn>
              </template>
            </v-menu>
          </template>
        </div>
      </div>
    </v-card>
    <div
      :style="!$vuetify.breakpoint.mdAndUp ? 'width: 100%;' : 'width: 480px;'"
      class="paymentLog pa-4"
      style="background: #fff;"
    >
      <div
        class="my-3 d-flex align-center"
        style="width: 100%"
      >
        <h3>{{ $t('bill_log') }}</h3>
      </div>
      <v-divider />
      <div
        v-dragscroll
        class="my-3"
        style="max-height: calc(100vh - 560px);overflow:hidden"
      >
        <template v-for="(paymentInfo,index) in paymentLog">
          <v-sheet
            :key="'price'+paymentInfo.hash"
            :elevation="0"
            class="d-flex justify-space-between pa-2 my-1"
            style="width: 100%"
          >
            <h2
              class="font-weight-bold"
              style="font-size: 24px"
            >
              {{ paymentInfo.price|priceDisplay }}
            </h2>
            <div>
              <v-btn
                color="success"
                text
              >
                <template v-if="paymentInfo.icon.startsWith('mdi')">
                  <v-icon large>
                    {{ paymentInfo.icon }}
                  </v-icon>
                </template>
                <template v-else>
                  {{ paymentInfo.icon }}
                </template>
              </v-btn>
              <v-btn
                color="error"
                icon
                @click="withdrawPayment(index)"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </v-sheet>
          <v-divider :key="'d'+paymentInfo.hash" />
        </template>
      </div>
      <div v-if="readyToCheckOut">
        <v-sheet class="my-6">
          <h4>
            {{ $t('tableCheckOutBillTypeLabel') }}
          </h4>
          <v-sheet
            class="my-2"
            style="background: transparent"
          >
            <v-chip-group
              v-model="billType"
              active-class="primary--text"
              column
              mandatory
            >
              <v-chip
                label
                x-large
              >
                {{ $t('tableCheckOutBillTypeOptionNormal') }}
              </v-chip>
              <v-chip
                label
                x-large
              >
                {{ $t('tableCheckOutBillTypeOptionCompany') }}
              </v-chip>
              <v-chip
                label
                x-large
              >
                {{ $t('tableCheckOutBillTypeOption3') }}
              </v-chip>
            </v-chip-group>
          </v-sheet>
        </v-sheet>
        <v-divider class="my-3" />

        <v-btn
          :disabled="!readyToCheckOut"
          block
          color="success"
          elevation="0"
          x-large
          @click="checkOut()"
        >
          {{ $t('save') }}
        </v-btn>
      </div>
      <div v-else>
        <h4>{{ $t('fast_check_out_without_tips') }}</h4>

        <v-btn
          :disabled="paymentLog.length!==0"
          block
          class="mt-2"
          color="amber lighten-4 black--text"
          elevation="0"
          x-large
          @click="checkOut(true)"
        >
          {{ $t('QuickBill') }}
        </v-btn>
      </div>
      <v-btn
        block
        class="mt-2"
        color="error"
        outlined
        x-large
        @click="cancel"
      >
        {{ $t('cancel') }}
      </v-btn>
    </div>
  </div>
</template>

<script>

import { dragscroll } from 'vue-dragscroll'
import hillo from 'hillo'
import { uuidv4 } from '@/main'
import BackButton from '@/views/widget/uiComponent/BackButton.vue'
import PageHeader from '@/views/widget/typography/PageHeader'
import i18n from '@/i18n'
import { fastSweetAlertRequest } from '@/model/utils/utils'

const includedPaymentMethods = [0, 1, 2, 9, 4, 10]
const defaultRealName = {
  'mdi-minus': 'reverse',
  'mdi-backspace': 'back',
  'mdi-restart': 'clear',
  'mdi-circle-small': '.',
  BAR: '1',
  RÜC: '1',
  TIP: '9',
  EC: '2',
  KreditCard: '3',
  Gutschein: '4',
  'mdi-dots-horizontal': 'more'
}
export default {
  name: 'CheckOutCalculator',
  components: {
    PageHeader,
    BackButton
  },
  props: {
    title: {
      type: String,
      default: i18n.t('billDetail')
    },
    total: {
      default: 0
    },
    id: { // use orderId as default,when not passed, will be a random string instead.
      default: uuidv4()
    }
  },
  directives: {
    dragscroll
  },
  data: function () {
    return {
      billType: 0,
      paymentMethods: [],
      realName: defaultRealName,
      inputBuffer: '',
      extraPaymentMethod: [
        'mdi-card-account-details',
        'mdi-cards'
      ],
      extraPaymentMethodName: ['Gutschein'],
      paymentLog: [],
      milePayLog: []
    }
  },
  computed: {
    keyArr: function () {
      if (this.remainTotal >= 0) {
        return [
          [1, 2, 3, 'mdi-minus'],
          [4, 5, 6, 'mdi-backspace'],
          [7, 8, 9, 'EC'],
          ['', 0, 'mdi-circle-small', 'BAR']
        ]
      } else {
        return [
          [1, 2, 3, 'mdi-minus'],
          [4, 5, 6, 'mdi-backspace'],
          [7, 8, 9, 'TIP'],
          ['', 0, 'mdi-circle-small', 'RÜC']
        ]
      }
    },
    realExtraPaymentMethod: function () {
      const res = this.extraPaymentMethod
      res.push(...this.paymentMethods.map(p => p.icon || p.id))
      return res
    },
    realExtraPaymentMethodName: function () {
      const res = this.extraPaymentMethodName
      res.push(...this.paymentMethods.map(p => p.name))
      return res
    },
    remainTotal: function () {
      const logTotal = this.paymentLog.reduce((cry, i) => {
        cry += parseFloat(i.price)
        return cry
      }, 0)
      return this.total - logTotal
    },
    readyToCheckOut: function () {
      return this.equals(this.remainTotal, 0) && this.paymentLog.length !== 0
    }
  },
  created () {
    this.loadPaymentMethods()
  },
  methods: {
    async loadPaymentMethods () {
      this.paymentMethods = (await hillo.get('PayMethod.php'))
        .content.filter(p => !includedPaymentMethods.includes(parseInt(p.id)))
        .map(p => {
          p.name = p.langs[0].name
          return p
        })
      this.realName = Object.assign({}, defaultRealName)
      this.paymentMethods.forEach(p => {
        this.$set(this.realName, p.name, p.id)
      })
    },
    equals (a, b) {
      return Math.abs(a - b) < 0.001
    },
    checkOut (fastCheckout = false) {
      if (fastCheckout) {
        this.billType = 0
      }
      this.$emit('payment-submit', this.paymentLog, this.billType)
      this.clearBuffer()
      this.paymentLog = []
    },
    cancel () {
      this.clearBuffer()
      this.paymentLog = []
      this.$emit('payment-cancel')
    },
    clearBuffer () {
      this.inputBuffer = ''
    },
    readBuffer (clear = true) {
      if (this.inputBuffer === '') {
        return this.remainTotal
      }
      const read = parseFloat(this.inputBuffer.trim())
      if (clear) {
        this.clearBuffer()
      }
      if (isNaN(read)) {
        return 0
      }
      return read
    },
    addPaymentLogToList (id, price, icon, hash, memberCardId = null) {
      this.paymentLog.push({
        id,
        price,
        icon,
        hash,
        memberCardId
      })
      if (parseInt(id) !== 1 && !this.equals(this.remainTotal, 0)) {
        if (this.remainTotal < 0) {
          this.paymentLog.push({
            id: 9,
            price: this.remainTotal,
            icon: 'TIP',
            hash: +this.paymentLog.length + 'p' + price + 'icon' + icon
          })
        }
      }
    },
    async logPayment (type) {
      const price = this.readBuffer()
      if (price === 0) {
        return
      }
      const icon = Object.entries(this.realName).find(([k, v]) => v === type)[0]
      const hash = this.paymentLog.length + 'p' + price + 'icon' + icon
      const obj = {
        id: type,
        price,
        icon,
        hash
      }

      if (parseInt(type) === 4) {
        const res = await fastSweetAlertRequest(
          i18n.t('EnterVoucherId'),
          'text', 'MemberCard.php?op=check', 'id',
          { amount: 0 }, 'GET')

        if (res.content) {
          const leftAmount = parseFloat(res.content.leftAmount)
          obj.price = leftAmount > price ? price : leftAmount
          obj.memberCardId = res.content.id
        } else {
          return
        }
      }
      this.addPaymentLogToList(obj.id, obj.price, obj.icon, obj.hash, obj.memberCardId)
    },
    withdrawPayment (index) {
      this.paymentLog.splice(index, 1)
    },
    async input (input) {
      if (!isNaN(parseInt(input))) {
        this.inputBuffer += input
      } else {
        const c = this.realName[input]
        switch (c) {
          case '.':
            this.inputBuffer += c
            break
          case 'back':
            this.inputBuffer = this.inputBuffer.substr(0, this.inputBuffer.length - 1)
            break
          case 'clear':
            this.clearBuffer()
            break
          case 'reverse':
            this.inputBuffer = this.inputBuffer.startsWith('-')
              ? this.inputBuffer.substr(
                1)
              : ('-' + this.inputBuffer)
            break
          case 'more':
            break
          case '10':
            this.logPayment(c)
            break
          default:
            this.logPayment(c)
        }
      }
    }
  }
}
</script>

<style scoped>

.totalNumber {
  width: fit-content;
  font-size: 24px;
}

.payingNumber {
  width: fit-content;
  font-size: 42px;
}

.keyboard {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 4px;
}

.key {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 48px;
  height: auto;
  border-radius: 5px;
  color: black;
}

</style>
